export default "__VITE_ASSET__f83d9941__"